import { newAxiosIns } from '@/libs/axios'

export default function apiGetShipment() {
  return newAxiosIns.get('komship/api/v1/komchat/shipment')
}
